// extracted by mini-css-extract-plugin
export default {"jobMain":"EditJob_jobMain__s6N1e","jobForm":"EditJob_jobForm__QEwCw","inputRow":"EditJob_inputRow__2tbPQ","reactQill":"EditJob_reactQill__-V7b4"};